import React, { useEffect, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer, InputBase } from '@mui/material';
import { Box } from '@mui/system';
import InputStylefield from '../../assets/InputStylefield';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { deleteJobById, getAllJobs, updateJob } from '../../actions/userAuth';
import { enqueueSnackbar } from 'notistack';
import SearchIcon from '@mui/icons-material/Search';
import Navbar from '../Navbar';
import CoachSideBar from './Profile/CoachSideBar';
import { servicefeature } from '../../styles/style'
import VisibilityIcon from '@mui/icons-material/Visibility';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';


export default function ServiceSessionsDetail() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [jobs, setJobs] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllJobs({}, (data) => {
            setJobs(data.data);
        }))
    }, []);

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = (index) => {
        var temp = [...jobs];
        temp[index].isActive = !temp[index].isActive;
        dispatch(updateJob(temp[index]._id, temp[index], {}, (data) => {
            console.log(data);
            enqueueSnackbar("Status updated successfully", { variant: 'success' });
            setJobs(temp);
        }, (err) => {
            enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        }))
    };

    const handleDeleteJob = (index) => {
        var temp = [...jobs];
        console.log(temp[index]._id);
        dispatch(deleteJobById(temp[index]._id, {}, (data) => {
            temp.splice(index, 1);
            setJobs(temp);
            enqueueSnackbar("Job deleted successfully", { variant: 'success' });
        }, (err) => {
            enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        }))
    }

    const Headings = [
        "Services Name", "Starting Date", "Session", "Attend Duration", "Completed Date", "Upcoming Date", " Status By Coach", "Action"
    ]

    const data = [
        { id: 1, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Deactivate', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Activate', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const navigate = useNavigate();
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    const handleChange2 = () => {
        setChecked("");
    };
    return (
        <Box>
            <Box>
                <Navbar />
            </Box>

            <Grid container mt={10} spacing={2} sx={{ bgcolor: "#fff" }}>
                <Grid item md={3} mx={3}>
                    <CoachSideBar />
                </Grid>
                <Grid item md={8}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography
                            className='subHeading1Bold'
                        >
                            Service Session(s) Details
                        </Typography>
                        <Box>
                            <TextField
                                // sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                                variant="outlined"
                                size="small"
                                sx={{ backgroundColor: '#D9E3F6' }}
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Box>
                    </Box>

                    <Paper sx={{ my: 3, px: 3, py: 2 }}>
                        <Grid container my={2} >
                            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                                <Typography className='text2Bold'>Show</Typography>
                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                    className='profile-skills-box text2Light'

                                    value={selectedOption}
                                    onChange={handleChange2}
                                >
                                    <option value="">none</option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                                <Typography className='text2Bold' mx={2}>Enteries</Typography>

                            </Grid>
                            <Grid item md={4}></Grid>

                            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                                <Typography className='text2Bold' mx={2}>Search</Typography>
                                <TextField
                                    // sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                                    variant="outlined"
                                    size="small"
                                    sx={{ backgroundColor: '#D9E3F6' }}
                                    InputProps={{
                                        endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                    }}
                                />
                            </Grid>
                        </Grid >
                        <Grid container>
                            <Grid item xs={12}>
                                <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                                    <Table width="auto">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Services Name
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Starting Date
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Session
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Attend Duration
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Completed Date
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Upcoming Date
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Upcoming Date
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            <TableRow>
                                                <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE' }}>
                                                    <p className='text2Mid' style={{ margin: '0px' }}>UI-UX Design</p>
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', }}>24- April
                                                    2023
                                                </TableCell>

                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center',  }}>
                                                    1 Session/60 minutes
                                                </TableCell>

                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    {/* <IconButton aria-label="Toggle visibility">
                                                        <RemoveRedEyeOutlinedIcon sx={{ color: '#005CF6' }} />
                                                    </IconButton> */}
                                                    50 minutes
                                                </TableCell>

                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', }}>
                                                    24- April 2023
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', }}>
                                                    26- April 2023
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', color: '#17BB05' }}>
                                                    Completed
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', color: '#B86E9F' }}>
                                                    Resheduled
                                                </TableCell>
                                            </TableRow>
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Grid>
            </Grid >
        </Box >

    );
}
